module.exports = __webpack_public_path__ + "static/media/bg2.2c82f6d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/contents/editorPreview/layout/components/Layout/bg/bg2.jpg
// module id = 3309
// module chunks = 0